import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';
import ko from './locales/ko.json';
import zh from './locales/zh.json';

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ko: { translation: ko },
    es: { translation: es },
    zh: { translation: zh },
  },
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'ko', 'es', 'zh'],
  interpolation: { escapeValue: false },
});

export default i18n;
